import { React, useState} from "react";
import { Outlet, useSearchParams} from "react-router-dom"
import QueryNavLink from "./Custom-Behavior";

 
const Countries = ({data}) => {
  const [searchParams, setSearchParams] = useSearchParams("")
  const [state, setState] = useState(data)
  const [inputValue, setInputValue] = useState("")

  return (
    <section className="grid-display">
      <nav>
        <div className="max-w-[85%] mx-auto text-center my-16 disapear">
        <input 
        type="text"
        value={searchParams.get("filter") || inputValue}
        placeholder="Search by starting letter"
        onChange={(event) => {
           let filter = event.target.value ;
          if (filter) {
            setSearchParams({filter}); 
            const myData = data.filter((data) => {
              let result = data.name.toLowerCase().startsWith(filter?.toLowerCase().trim());
              return result
            })
            setState(myData)
          } else {
            setState(data)
            setSearchParams({});
          } 
        }}
        style={{textIndent: 0,}}
        /> 
        <div
        onClick={()=>{
          setInputValue(() => "")
          setSearchParams(() => "")
          setState(() => data)
        }}
        className="neon-button"
        >
          Reset
        </div>
        </div>
        <section className="py-4 border border-solid border-r-1 border-y-0 border-l-0 max-w-[16rem] mx-4 meanu-border">
          <div>
         <QueryNavLink
          to={"/countries/allcountries"}
          className="text-white  text-xl underline-offset-2 hover:text-yellow-400 active:text-red-600">
              All Countries
          </QueryNavLink> 
          </div>
          
        {state.filter((country) => {
          let filter = searchParams.get("filter");
          if(!filter) return true;
          let name = country.name.toLowerCase();
          return name.startsWith(filter.toLowerCase());
        }).map((Datas) => (
          <section key={Datas.name} >
          <QueryNavLink to={`/countries/${Datas.population}`}
          key={Datas.name} style={({isActive}) => {
            return {
              color: isActive ? "yellow" : "#ff41bd",
            }
          }}
          className="menue-link"
          >
          {Datas.name}
          </QueryNavLink >
          </section>
        ))}
        </section>
      </nav>
      <Outlet />
    </section>
  )
}



export default Countries

